import { Container } from 'react-bootstrap';
import SubPage from '../subpages/SubPage';

const Course = () => {
  const pillInfo = {
    margin: '1rem 1rem 0rem 1rem',
    width: '8rem',
  };
  const title = '대회 코스';
  const parent_link = 'course';
  const side_list = [
    // ["ultra", "울트라 35"],
    ['half', '하프 코스'],
    ['mini', '미니 코스'],
    ['health', '건강 코스'],
  ];
  const bg_info = {
    link: '/marathon_banner.jpeg',
    text: title,
  };
  return (
    <div style={{ minHeight: '70rem' }}>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        isOnePage={true}
        background_info={bg_info}
      />
      <Container fluid className="col-lg-8 offset-lg-3">
        <h1 className="pt-5 mb-5">대회 코스</h1>
        <Container id="half">
          <h1 className="pt-5 mb-5">하프 코스</h1>
          <img alt="하프코스" src="/2024_half.jpeg" width={'100%%'} />
          <img alt="하프코스 고저도" src="/half_elevation.png" width={'100%%'} />
          <h5 className="text-primary">코스특징</h5>
          <p>
            아름다운 자연경관과 깨끗한 주변환경을 자랑하는 금강과 대청호를 연결하는 코스로 1차
            반환점을 돌아 6.0km 지점에서 시작되는 600여 미터의 고갯길이 가장 어려운 코스지만,
            고갯마루에 올라서면 대청호의 탁 트인 전경과 오색의 가로수를 곁에 두고 완만한 오르내림을
            반복, 달림이 여러분의 오감을 열어주는 대청호 마라톤의 색다른 맛에 취하게 됩니다.
          </p>
          <h5 className="text-primary">주요코스</h5>
          <p>
            출발(대청공원) → 미호마을 → 미호교 → 삼정취수장 → 용호교(보조댐) → 에코공원/대청대교(1차
            반환점, 5km) → 삼정취수장 → 삼정고개 → 갈밭식당 → 송강식당(2차 반환점, 11.5km) →
            갈밭식당 → 삼정마을 → 공도교(비상여수로) → 미호마을 → 도착(대청공원)
          </p>
          <h5 className="text-primary">출발시간</h5>
          <p>
            오전 9시
            <br />
            <strong>
              (오전 8시30분까지 대청공원에 오셔서 본부의 안내에 따라 대회에 참가하셔야 하며,
              대회운영상 시간이 변경될 수도 있습니다.)
            </strong>
          </p>
        </Container>
        <Container id="mini">
          <h1 className="pt-5 mb-5">미니 코스</h1>
          <img alt="미니코스" src="/2024_mini.jpeg" width={'100%%'} />
          <h5 className="text-primary">코스특징</h5>
          <p>
            대청호마라톤대회의 중추적인 코스로 대청호 자연의 아름다움을 맘껏 만끽하며 달릴 수 있는
            왕복형 코스입니다. 대부분 평지로 구성되어 있어 수많은 달림이들이 기록갱신의 기회로
            삼고있는 코스이기도 합니다.
          </p>
          <h5 className="text-primary">주요코스</h5>
          <p>대청공원 ↔ 미호마을 ↔ 미호교 ↔ 삼정취수장 ↔ 용호교(보조댐) ↔ 에코공원/대청대교</p>
          <h5 className="text-primary">출발시간</h5>
          <p>
            오전 9시 15분
            <br />
            <strong>
              (오전 8시 30분까지 대청공원에 오셔서 본부의 안내에 따라 대회에 참가하셔야 하며,
              대회운영상 시간이 변경될 수도 있습니다.)
            </strong>
          </p>
        </Container>
        <Container id="health">
          <h1 className="pt-5 mb-5">건강 코스</h1>
          <img alt="건강코스" src="/2024_health.jpeg" width={'100%%'} />
          <h5 className="text-primary">코스특징</h5>
          <p>
            가족ㆍ이웃ㆍ친구ㆍ직장동료간 화합과 결속을 다질 수 있는 왕복코스로써 초보달림이들의
            마라톤입문의 계기가 되는 코스이기도 합니다.
          </p>
          <h5 className="text-primary">주요코스</h5>
          <p>대청공원 ↔ 미호마을 ↔ 비상여수로 입구 ↔ 미호교</p>
          <h5 className="text-primary">출발시간</h5>
          <p>
            오전 9시 30분
            <br />
            <strong>
              (오전 8시 30분까지 대청공원에 오셔서 본부의 안내에 따라 대회에 참가하셔야 하며,
              대회운영상 시간이 변경될 수도 있습니다.)
            </strong>
          </p>
        </Container>
      </Container>
    </div>
  );
};
export default Course;
